import {
  RECS_MVT_GUID_PARAM_NAME,
  RECS_MVT_CHANNEL_PARAM_NAME
} from "../../server/recs/constants";

export const SEARCH_REQUEST = "SEARCH_REQUEST";
export const CATEGORY_REQUEST = "CATEGORY_REQUEST";
export const CATEGORY_DETAILS_REQUEST = "CATEGORY_DETAILS_REQUEST";
export const BRANDS_REQUEST = "BRANDS_REQUEST";
export const FACET_REQUEST = "FACET_REQUEST";
export const SEARCH_MVT_PARAM_NAME = "key-search-mvtid";
export const SEARCH_MVT_FLAG_NAME = "isEnabled";

export const SEARCH_MVT_PARAMS = [
  SEARCH_MVT_PARAM_NAME,
  RECS_MVT_GUID_PARAM_NAME,
  RECS_MVT_CHANNEL_PARAM_NAME
];
